import type React from "react"
import { Box, Typography, Paper } from "@mui/material"
import type { PropertyInfoDto } from "../../types/message"

interface PropertyInfoCardProps {
  propertyInfo: PropertyInfoDto
}

const PropertyInfoCard: React.FC<PropertyInfoCardProps> = ({ propertyInfo }) => {
  return (
    <Paper
      elevation={1}
      sx={{
        p: 2,
        mb: 3,
        borderRadius: "12px",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Box
        component="img"
        src={propertyInfo.mainImage || "/assets/images/property-placeholder.jpg"}
        alt={propertyInfo.title}
        sx={{
          width: 80,
          height: 60,
          borderRadius: "8px",
          objectFit: "cover",
          mr: 2,
        }}
      />
      <Box>
        <Typography variant="subtitle1" sx={{ fontWeight: "medium" }}>
          {propertyInfo.title}
        </Typography>
        <Typography variant="body2" color="success.main" sx={{ fontWeight: "bold" }}>
          ${propertyInfo.price.toLocaleString()}
        </Typography>
      </Box>
    </Paper>
  )
}

export default PropertyInfoCard
